module.exports = __webpack_public_path__ + "static/img/booster.f4b3616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/booster.png
// module id = xNZv
// module chunks = 12